import { Stack } from '@mui/material'
import { preview } from '@/components/form/preview'
import { useAggregateLoadsCf } from '../../../../../components/DynamicLoadsCf/hooks/useAggregateLoadsCf'
import { useTexts } from '../useTexts'
import { NullValue } from '@/components/form/preview/components/NullValue'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function CustomFields(props: Props) {
  const { extOrder } = props

  const customFields = extOrder.orderStep.customFields || {}
  const trackedCustomFields = extOrder.orderStep.trackingData?.customFieldTrackedMap || {}

  const texts = useTexts()
  const { aggregateCustomFields } = useAggregateLoadsCf({
    loads: {},
    trackedLoads: {},
    customFields,
    trackedCustomFields,
  })

  if (aggregateCustomFields.length === 0) {
    return null
  }

  return (
    <Stack spacing={2}>
      {aggregateCustomFields.map((aggregateCustomField, idx) => {
        if (aggregateCustomField.type === 'undeclared') {
          return (
            <preview.Field
              key={aggregateCustomField.label}
              label={aggregateCustomField.label}
              testId={`execution-custom-field-${idx}`}
            >
              {texts.undeclared.label}
            </preview.Field>
          )
        }

        const { trackedValue } = aggregateCustomField
        const displayValue = trackedValue.trim() === '' ? <NullValue /> : trackedValue

        return (
          <preview.Field
            key={aggregateCustomField.label}
            label={aggregateCustomField.label}
            testId={`execution-custom-field-${idx}`}
          >
            {displayValue}
          </preview.Field>
        )
      })}
    </Stack>
  )
}
